import { COVERAGE_STATUS_LABEL } from '@/modules/projects/components/StatementCoverage/constants'
import type { CoverageStatus } from '@/modules/projects/components/StatementCoverage/types'
import { CoverageChip } from '@/modules/projects/components/Workbench/CoverageChip'
import {
  COVERAGE_SWATCH_CLASS,
  TALLIED,
} from '@/modules/projects/components/Workbench/coverage'
import type { Highlight } from '@/modules/projects/components/Workbench/mapView'

// The coverage page's legend explains each colour in full. Up here the colour already sits beside
// the count, so the words only have to say what was counted. The full wording stays on hover.
const SHORT_LABEL: Record<CoverageStatus, string> = {
  reconciled: 'reconciled',
  needs_review: 'need review',
  unverifiable: 'unverifiable',
  not_checked: 'not checked',
  member_activity: 'member activity',
  verified_gap: 'no statement issued',
  missing: 'missing',
}

interface HighlightChipsProps {
  counts: Record<CoverageStatus, number>
  highlight: Highlight
  onHighlight: (next: Highlight) => void
}

export const HighlightChips = ({
  counts,
  highlight,
  onHighlight,
}: HighlightChipsProps) => {
  const tallied = TALLIED.filter((status) => counts[status] > 0)
  if (tallied.length === 0) return null
  return (
    <div className="flex w-max items-center gap-1.5">
      {tallied.map((status) => (
        <CoverageChip
          key={status}
          label={SHORT_LABEL[status]}
          title={COVERAGE_STATUS_LABEL[status]}
          count={counts[status]}
          dotClassName={COVERAGE_SWATCH_CLASS[status]}
          isActive={highlight === status}
          onClick={() => onHighlight(highlight === status ? null : status)}
        />
      ))}
    </div>
  )
}
